import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.page.html',
  styleUrls: ['./my-orders.page.scss'],
})
export class MyOrdersPage implements OnInit {
  placeOrderData:any = []
  progressOrderData:any = []
  defaulatTab:any = "pending"
  selectedTab:any = "pending"
  constructor(public api: ApiService,private router: Router) { }

  ngOnInit() {
    // Get the information from the API
    this.getPlaceOrderDetails()

    this.getProcessDatalist()
  }

  getPlaceOrderDetails(){
    this.placeOrderData= []
    try {  
      this.api.getPlaceOrderHistory().subscribe((result:any) => {
        if(result.status == true){
          if(result.data.length > 0){
            this.placeOrderData = result.data
          }
        }
      },(err)=>{
        console.log(err)
      });
    }
    catch (error) {
      console.error('Here is the error message', error);
    }
  }

  getProcessDatalist(){
    this.progressOrderData = []
    try {
      this.api.getProgressOrderHistory().subscribe((result:any) => {
        if(result.status == true){
          if(result.data.length > 0){
            this.progressOrderData = result.data
          }
        }
      },(err)=>{
        console.log(err)
      });
    }
    catch (error) {
      console.error('Here is the error message', error);
    }
  }

  segmentChanged(ev: any) {
    console.log('Segment changed', ev);
    this.selectedTab = ev.detail.value
    if(ev.detail.value == "pending"){
      this.getPlaceOrderDetails()
    }
    else{
      this.getProcessDatalist()
    }
  }

  getOrderStatus(value:any){
    if(value == 1){
      return "Placed"
    }
    else if(value == 2){
      return "In-Progress"
    }
    else if(value == 3){
      return "Delivered"
    }
    else if(value == 4){
      return "Received"
    }
    else if(value == 0){
      return "Pending"
    }
  }

  goToProductDetails(item:any) {
    let data:any = {
      item : JSON.stringify(item)
    }
    this.router.navigate(['/order-details', data]);
  }

}
